import { type RootState } from '../../stores/redux';
import { ModalId } from './modals.type';

export const getIsModalOpen = (state: RootState, modalId: ModalId) =>
  state.modals.current === modalId;

/** True when the given modal should render with no transition (e.g. opened as a step, or closing as the replaced modal). */
export const getShouldDisableTransitionForModal = (
  state: RootState,
  modalId: ModalId,
) =>
  (state.modals.current === modalId && state.modals.disableTransition) ||
  state.modals.exitWithoutTransition === modalId;

// Modals that won't hide callControls & inCallViewPanel
const excludedModalId = ModalId.AddToGroupCall;

export const getIsAnyModalOpen = (state: RootState) =>
  state.modals.current !== null && excludedModalId !== state.modals.current;
